// ======================================================
// Treat Animation
// ======================================================

const TREAT_IMAGE =
  "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Temp_Treat.png?v=1787429208";

window.playTreatAnimation = function (button) {

  if (!button) return;

  const card = button.closest(".treat-card");

  if (!card) return;

  const catImage =
    card.querySelector("img") ||
    card.querySelector(".cat-image");

  if (!catImage) return;

  const buttonRect = button.getBoundingClientRect();
  const catRect = catImage.getBoundingClientRect();

  const treat = document.createElement("img");

  treat.src = TREAT_IMAGE;

  treat.style.position = "fixed";
  treat.style.width = "60px";
  treat.style.height = "60px";

  treat.style.left =
    `${buttonRect.left + buttonRect.width / 2 - 30}px`;

  treat.style.top =
    `${buttonRect.top + buttonRect.height / 2 - 30}px`;

  treat.style.pointerEvents = "none";
  treat.style.zIndex = "999999";

  treat.style.transition =
    "left 1.3s cubic-bezier(.2,.8,.2,1), top 1.3s cubic-bezier(.2,.8,.2,1), transform 1.3s cubic-bezier(.2,.8,.2,1), opacity 1.3s ease";

  treat.style.transform =
    "translate(0,0) rotate(0deg) scale(1)";

  treat.style.opacity = "1";

  document.body.appendChild(treat);

  requestAnimationFrame(() => {

    treat.style.left =
      `${catRect.left + catRect.width / 2 - 30}px`;

    treat.style.top =
      `${catRect.top + catRect.height / 2 - 30}px`;

    treat.style.transform =
      "translateY(-80px) rotate(360deg) scale(.7)";

    treat.style.opacity = "0";

  });

  setTimeout(() => {

    treat.remove();

  }, 1400);

};